export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9414.d5addf08.jpg";